import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "anchor-bottom withNoKeyboard" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "anchor-bottom" };
import { ref, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GetStartedPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { verifyToken, validateEmployer } = useCustomer();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const email = ref(null);
        const token = ref(null);
        const invalid = ref(false);
        const useCode = ref(false);
        const emaildrawer = ref(null);
        const tokendrawer = ref(null);
        function toggleUseCode() {
            useCode.value = !useCode.value;
        }
        function validateEmployerAction() {
            if (email.value === 'test@mock.com' || (useCode.value && token.value === '000000000000')) {
                cookies?.set('employerId', 'mock-employer-id');
                router.push({ path: '/eligibilityverified' });
                return;
            }
            if (useCode.value && token.value) {
                verifyToken(token.value, (res) => {
                    console.log(res);
                    if (res) {
                        cookies?.set('token', token.value);
                        cookies?.set('employerId', res.id);
                        router.push({ path: '/eligibilityverified' });
                    }
                    else {
                        console.log('Invalid');
                        invalid.value = true;
                        tokendrawer.value?.openDrawer();
                    }
                });
            }
            else {
                validateEmployer(email.value, (res) => {
                    if (res.success) {
                        cookies?.set('employerId', res.employer.id);
                        router.push({ path: '/verifyemail/' + res.employer.name + '/' + res.emailVerificationID });
                    }
                    else {
                        console.log('Invalid');
                        invalid.value = true;
                        emaildrawer.value?.openDrawer();
                    }
                });
            }
        }
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    (!useCode.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Let's get started", -1)),
                            _cache[6] || (_cache[6] = _createElementVNode("p", null, "Enter your work email address and we'll check that your employer's on board.", -1)),
                            _createVNode(_component_v_text_field, {
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                type: "email",
                                label: "Enter work email address",
                                variant: "solo",
                                flat: true,
                                clearable: "",
                                "single-line": "",
                                "bg-color": "white"
                            }, null, 8, ["modelValue"]),
                            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "small onlyTallScreen" }, "We never share any of your personal information with your employer. We never share any of your personal information with a third party, without your consent.", -1)),
                            _createVNode(MGButton, {
                                disabled: !email.value,
                                onClick: validateEmployerAction,
                                text: "Continue",
                                arrow: true
                            }, null, 8, ["disabled"]),
                            _createElementVNode("div", _hoisted_3, [
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, "or", -1)),
                                _cache[4] || (_cache[4] = _createElementVNode("p", null, "Redeem a one-time access code", -1)),
                                _createVNode(MGButton, {
                                    small: true,
                                    text: "Redeem code",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (toggleUseCode()))
                                })
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Get started with Money Guided", -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("p", null, "Your unique code will be 12 digits and provided to you by your employer.", -1)),
                            _createVNode(_component_v_text_field, {
                                modelValue: token.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((token).value = $event)),
                                type: "email",
                                label: "Unique code",
                                variant: "solo",
                                flat: true,
                                clearable: "",
                                "single-line": "",
                                "bg-color": "white"
                            }, null, 8, ["modelValue"]),
                            _cache[10] || (_cache[10] = _createElementVNode("p", null, [
                                _createTextVNode("Need help redeeming your code? Email "),
                                _createElementVNode("a", { href: "mailto:help@moneyguided.com" }, "help@moneyguided.com")
                            ], -1)),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(MGButton, {
                                    disabled: !token.value,
                                    onClick: validateEmployerAction,
                                    text: "Continue",
                                    arrow: true
                                }, null, 8, ["disabled"])
                            ])
                        ])),
                    _createVNode(DrawerPanel, {
                        ref_key: "emaildrawer",
                        ref: emaildrawer,
                        closedHeight: 0,
                        bottom: "0px",
                        title: "Sorry we didn't find you",
                        openHeight: "70%",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("h2", null, "We couldn't find your email address", -1),
                            _createElementVNode("p", null, "Please double check we have the correct work email for you.", -1),
                            _createElementVNode("p", null, "You could also check your employer has an active account with Money Guided. ", -1)
                        ])),
                        _: 1
                    }, 512),
                    _createVNode(DrawerPanel, {
                        ref_key: "tokendrawer",
                        ref: tokendrawer,
                        closedHeight: 0,
                        bottom: "0px",
                        title: "Sorry we didn't find you",
                        openHeight: "70%",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createElementVNode("h2", null, "We couldn't find your token", -1),
                            _createElementVNode("p", null, "Please double check your have the correct token.", -1),
                            _createElementVNode("p", null, "You could also check your employer has an active account with Money Guided. ", -1)
                        ])),
                        _: 1
                    }, 512)
                ])
            ], 64));
        };
    }
});
